import { render } from "./DemoPage.vue?vue&type=template&id=3c0a5195"
import script from "./DemoPage.vue?vue&type=script&lang=js"
export * from "./DemoPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__